// ── RegCompletion edit view: mail-template filter ───────────────────────────
// Port of the legacy inline jQuery block "Mail-Template Filter"
// (trigger_show_or_hide_mail_links in render_complete_registration.cipp-module).
// Per legitimation level the edit view renders an approve/disapprove select
// (.label_filter_action), a "send mail" checkbox (#send_legi_mail_<level>) and
// one preview-link span per level/option/language (.lang_filter, inline
// display:none). On every level/language change: show the span matching the
// selected registration language + level option, enable the mail checkbox —
// unless the mail-template page is missing (span carries
// .error_missing_page_id) — and toggle the disapproval-message box.
//
// TODO(FMT-5800): Nach der Backend-Anpassung (geparkter visit-custom-Patch,
// Branch feat-fmt-5800-nacherfassung-vanilla-js) refaktorieren: das
// Script-Sniffing in detectAutoCheck() durch ein
// data-auto-check-send-legi-mail-Attribut am Container ersetzen.
(function () {
    'use strict';

    // Set window.regcomplMailFilterDebug = true in devtools for verbose logging.
    function dbg() {
        if (window.regcomplMailFilterDebug) console.log.apply(console, ['[regcompl-mail-filter]'].concat(Array.prototype.slice.call(arguments)));
    }

    var levelSelects = document.querySelectorAll('.label_filter_action');
    if (!levelSelects.length) return;

    var langSelect = document.getElementById('adrfree_s_reg_language');

    // vit_regi.auto_check_send_legi_mail is baked into the (dead) legacy
    // inline script via CIPP <?IF?> — no markup attribute carries the value.
    // Sniff the generated script text instead: the line `.prop('checked',
    // true)` is only emitted when the property is on. Fallback = property
    // default (1/on).
    function detectAutoCheck() {
        var scripts = document.querySelectorAll('script:not([src])');
        for (var i = 0; i < scripts.length; i++) {
            var text = scripts[i].textContent || '';
            if (text.indexOf('trigger_show_or_hide_mail_links') !== -1) {
                return text.indexOf(".prop('checked', true)") !== -1;
            }
        }
        return true;
    }

    var autoCheck = detectAutoCheck();
    dbg('init', { levels: levelSelects.length, autoCheck: autoCheck, langSelect: !!langSelect });

    // Spans carry inline style="display: none" from the backend, so toggle
    // the inline style (clearing it restores the element's natural display).
    function setHidden(el, hidden) {
        el.style.display = hidden ? 'none' : '';
    }

    function update() {
        var selectedLang = langSelect ? langSelect.value : '';
        var disapproval  = document.getElementById('regcompl_disapproval_mail_message');

        Array.prototype.forEach.call(document.querySelectorAll('.label_filter_action'), function (select) {
            var level     = select.getAttribute('name');
            var selection = select.value;
            var checkbox  = document.getElementById('send_legi_mail_' + level);

            // Match spans by classList (not a built selector) — level labels
            // are free-form option labels and may not be selector-safe.
            Array.prototype.forEach.call(document.querySelectorAll('.lang_filter'), function (span) {
                if (!span.classList.contains(level)) return;

                if (selection !== '' && selectedLang &&
                    span.classList.contains(selectedLang) &&
                    span.classList.contains(selection)) {
                    setHidden(span, false);
                    if (checkbox) {
                        // Missing mail-template page → error span shown, mail
                        // must not be offered for sending.
                        if (span.classList.contains('error_missing_page_id')) {
                            checkbox.disabled = true;
                            checkbox.checked  = false;
                        } else {
                            checkbox.disabled = false;
                            if (autoCheck) checkbox.checked = true;
                        }
                    }
                } else {
                    setHidden(span, true);
                }

                if (selection === '' && checkbox) {
                    checkbox.disabled = true;
                    if (autoCheck) checkbox.checked = false;
                }

                // Legacy also set `disabled` on this element — it is a <div>,
                // so that was a no-op and the textarea inside keeps submitting
                // its value; replicated as show/hide only (disabling the
                // textarea would change the submitted form data).
                if (disapproval) {
                    setHidden(disapproval, selection === '' || selection === 'approve');
                }
            });
        });
    }

    Array.prototype.forEach.call(levelSelects, function (select) {
        select.addEventListener('change', update);
    });
    if (langSelect) {
        langSelect.addEventListener('change', update);
        // Legacy initialized by firing jQuery("#adrfree_s_reg_language")
        // .change() on load — i.e. only when the language select exists.
        update();
    }
})();
